<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <!-- <v-card-title class="ma-0 pa-0 my-4">
          <v-row class="ma-0">
            <v-spacer></v-spacer>
          </v-row>
        </v-card-title> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          :headers="headers"
          class="datatable"
          :items="promotionsLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalPromotions"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                promotionsLists
                  .map(function(x) {
                    return x._id;
                  })
                  .indexOf(item._id) + 1
              }}
            </p>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-switch
              @click="disableEnablePromotionCharge(item)"
              v-if="!footer"
              class="ma-0"
              value
              v-model="item.isActive"
              color="primary"
            ></v-switch>
            <span v-else>{{ item.isActive ? "true" : "false" }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-0" justify="center">
              <v-icon color="primary" @click="editProtionCharges(item)">
                mdi-pencil</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { disableEnablePromotionCharge } from "../methods/fee/disable_enable_promotin_charges";
export default {
  data() {
    return {
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      promotionsLists: [],
      totalPromotions: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "_id",
          width: 10
        },
        {
          text: this.$t("settings.promotionCharge.propertyName"),
          align: "left",
          sortable: false,
          value: "propertyType.nameEn",
          width: 10
        },
        {
          text: this.$t("settings.promotionCharge.price"),
          align: "left",
          sortable: false,
          value: "price",
          width: 10
        },
        {
          text: this.$t("landlord.isActive"),
          align: "left",
          sortable: false,
          value: "isActive",
          width: 10
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          align: "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    options() {
      this.$apollo.queries.getAllPromotionCharges.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPromotions,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        }
      });
    }
  },
  apollo: {
    getAllPromotionCharges() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/fee/get_promotion_charges_query.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.promotionsLists = this.$format.cloneVariable(
            data.getAllPromotionCharges.promotionCharges
          );
          this.loading = loading;
          this.totalPromotions = data.getAllPromotionCharges.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("refetchFee", () => {
      this.loading = true;
      this.$apollo.queries.getAllPromotionCharges.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPromotions,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        }
      });
      this.loading = false;
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", { dialog: true, item: item });
    },
    editProtionCharges(item) {
      this.$store.commit("IS_EDIT_PROMOTION", true);
      this.$store.commit("EDIT_PROMOTION", item);
      this.$store.commit("APP_SETTINGS_FORMNAME", "FEE");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    disableEnablePromotionCharge(item) {
      disableEnablePromotionCharge({
        promotionChargeId: item._id,
        isActive: item.isActive
      }).then(response => {
        if (response.data.disableEnablePromotionCharge) {
          this.$apollo.queries.getAllPromotionCharges.refetch({
            input: {
              limit:
                this.options.itemsPerPage !== -1
                  ? this.options.itemsPerPage
                  : this.totalPromotions,
              skip:
                this.options.page * this.options.itemsPerPage -
                this.options.itemsPerPage
            }
          });
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: "Promotion charges status changed successfully",
            color: "green"
          });
        }
      });
    }
  },
  beforeDestroy() {
    this.$root.$off("refetchFee");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
